import { useEffect, useState } from "react";

/**
 * Hook minimale per media query. Usato per il layout mobile (item 15):
 * la logica desktop resta di default, i rami mobile si attivano solo sotto
 * il breakpoint. SSR-safe (default false quando window non esiste).
 *
 * Esempio: `const isMobile = useMediaQuery("(max-width: 767px)");`
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (): void => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Breakpoint mobile del progetto: <768px (allineato a Tailwind `md`). */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
